import styled from 'styled-components';

const ContentContainer = styled.div`
  .container {
    width: 1140px;
    height: 100vh;
    align-self: center;
    display: flex;
    flex-direction: column;
  }

  .header-text {
    margin: 37px 0 11px;
    font-weight: 500;
    font-size: 20px;
  }

  .content-container {
    margin: 0 50px 32px 0;
  }

  .wrapped-area {
    flex-direction: row;
    flex-wrap: wrap;
    display: flex;
  }

  @media (max-width: 1024px) {
    .content-container {
      margin: 0 0 32px;
      align-items: center;
      width: 100%;
      justify-content: center;
      display: flex;
    }

    .container {
      width: 100vw;
      flex-wrap: unset;
      flex-direction: column;
      align-items: flex-start;
    }

    .header-text {
      margin: 0 17px 10px;
      font-weight: 500;
      font-size: 16px;
    }
  }
`;

export default ContentContainer;
